import type { EmailInlineAttachmentHint } from "./emailTemplate";

/**
 * API / forms sometimes store `user@host||admin` (role suffix). Only the part before `||` is a valid mailbox.
 */
export function sanitizeMailbox(raw: string | undefined | null): string {
  const s = String(raw ?? "").trim();
  if (!s) return "";
  const i = s.indexOf("||");
  return i >= 0 ? s.slice(0, i).trim() : s;
}

function sanitizeToList(to: string[]): string[] {
  return to.map(sanitizeMailbox).filter(Boolean);
}

export interface EmailPayload {
  to: string[];
  from: string;
  subject: string;
  body: string;
  attachments?: Record<string, string>;
  /**
   * For each entry, the email API should download `sourceUrl` and attach as inline/related with `cid`
   * so `cid:` image references in `body` resolve (avoids expiring URLs embedded in HTML).
   */
  inlineImageAttachments?: EmailInlineAttachmentHint[];
}

export async function sendEmail(payload: EmailPayload, jwt: string) {
  const to = sanitizeToList(Array.isArray(payload.to) ? payload.to : []);
  if (to.length === 0) {
    throw new Error("Email failed: no valid recipient addresses after sanitizing `to`.");
  }
  // Backend builds multipart/related + fetches cid images; must match POST body expected by SendEmailWithInlineImagesHandler.
  const res = await fetch(`${process.env.REACT_APP_API_URL}/email/send-inline-images`, {
    method: "POST",
    headers: {
      "Content-Type":  "application/json",
      "Authorization": `Bearer ${jwt}`
    },
    body: JSON.stringify({
      to,
      from: payload.from,
      subject: payload.subject,
      body: payload.body,
      attachments: payload.attachments ?? {},
      inlineImageAttachments: payload.inlineImageAttachments ?? [],
    })
  });

  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Email failed: ${err}`);
  }
  return res.json();
}















// src/utils/sendEmail.ts
// export interface EmailPayload {
//   to: string[];
//   from: string;
//   subject: string;
//   body: string;
//   attachments?: Record<string,string>;
// }
// export async function sendEmail(payload: EmailPayload, token: string) {
//   const res = await fetch(`${process.env.REACT_APP_API_URL}/email/send`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//     body: JSON.stringify({
//       to:          payload.to,
//       from:        payload.from,
//       subject:     payload.subject,
//       body:        payload.body,
//       attachments: payload.attachments || {}
//     }),
//   });
//   if (!res.ok) throw new Error(await res.text());
//   return res.json();
// }
